import React, { useEffect, useState } from "react";
import GlobalDialog from "../../mui/Dialogue/GlobalDialog";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import {
  AddButton,
  CancelButton,
  EditButton,
  SubmitButton,
  UpdateButton,
} from "../../mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { savePaginationData } from "../../../redux/features/globalDatagridSlice";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  createLsqm,
  getLSQMDatas,
  getOgaListUnderSojo,
  updateLsqm,
} from "../../../redux/features/ogdSlice";

const DATA = [{ id: 1, name: "subhin" }];
const AddOrEditLSQM = ({ row ,dispatchParams}) => {
  console.log("dispatchParams",dispatchParams);
  
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading,ogaList } = useSelector((store) => store.ogd);
  const dispatch = useDispatch();
  const initialValues = {
    ogaId: row?row.userId:"",
    lsqId: row?row.lsUserId:"",
    lsqMail:  row?row.lsEmail:"",
  };

  useEffect(() => {
    if(open &&ogaList.length==0){
      dispatch(getOgaListUnderSojo());
    }
  }, [open]);
  const schema = Yup.object({
    ogaId: Yup.number().required("OGA Required"),
    lsqId: Yup.string().required("Lead Square Id is required"),
    lsqMail: Yup.string()
      .email("Invalid email address")
      .required("Invalid email address"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = {
        UserId: values.ogaId,
        leadsquaredId: values.lsqId,
        leadsquaredEmail: values.lsqMail,
      };

      if (row) {
        const updateData = { ...data, id: row.extenalId };
        dispatch(updateLsqm(updateData)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel()
            dispatch(getLSQMDatas(dispatchParams));
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      } else {
        dispatch(createLsqm(data)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel()
            dispatch(getLSQMDatas(dispatchParams));
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      }
    },
  });

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const handleOgaChange = (e,option) => {
    formik.setFieldValue("ogaId", option.userID);
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Action"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          {row ? (
            <EditButton
              disabled={!row.isEditable}
              size="small"
              variant={"outlined"}
              action={() => setOpen(true)}
            >
              Edit Mapping
            </EditButton>
          ) : (
            <AddButton size={"large"} action={() => setOpen(true)}>
              Add Mapping
            </AddButton>
          )}
        </>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Stack gap={1}>
                <Box sx={{ flex: 1 }}>
                  <Autocomplete
                    disabled={loading}
                    name="ogaId"
                    options={ogaList}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      ogaList?.find((oga) => oga.userID == formik.values.ogaId) || null
                    }
                    onChange={handleOgaChange}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="OGA Name"
                        error={
                          formik.touched.ogaId && Boolean(formik.errors.ogaId)
                        }
                        helperText={formik.touched.ogaId && formik.errors.ogaId}
                      />
                    )}
                  />
                </Box>

                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="lsqId"
                    label="Lead Square Id"
                    name="lsqId"
                    value={formik.values.lsqId}
                    onChange={formik.handleChange}
                    error={formik.touched.lsqId && Boolean(formik.errors.lsqId)}
                    helperText={formik.touched.lsqId && formik.errors.lsqId}
                  />
                </Box>

                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="lsqMail"
                    label="Lead Square Email"
                    name="lsqMail"
                    value={formik.values.lsqMail}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.lsqMail && Boolean(formik.errors.lsqMail)
                    }
                    helperText={formik.touched.lsqMail && formik.errors.lsqMail}
                  />
                </Box>
              </Stack>

              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <CancelButton action={() => handleCancel()}>
                    Cancel
                  </CancelButton>
                  {row ? (
                    <UpdateButton disabled={loading} type="submit">
                      {loading ? "Updating..." : "Update"}
                    </UpdateButton>
                  ) : (
                    <SubmitButton disabled={loading} type="submit">
                      {loading ? "Submiting..." : "Submit"}
                    </SubmitButton>
                  )}
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AddOrEditLSQM;
